import { Timestamp, collection, doc } from "firebase/firestore";

export const buildInventoryPriceChangeDetail = ({
  companyId,
  inventoryId,
  name,
  sku,
  category,
  changedBy,
  changedByLabel,
  from,
  to,
  source,
  type,
}) => ({
  companyId,
  inventoryId,
  name: name || "",
  sku: sku || "",
  category: category || "",
  changedAt: Timestamp.now(),
  changedBy: changedBy || null,
  changedByLabel: changedByLabel || null,
  source: source || "inventory",
  type: type || "updated",
  from,
  to,
});

export const createInventoryPriceChangeWrite = ({ db, companyId, detail }) => {
  const ref = doc(
    collection(db, "companies", companyId, "inventoryPriceChanges"),
    `${detail.inventoryId}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`
  );

  return {
    ref,
    payload: {
      inventoryId: detail.inventoryId,
      name: detail.name,
      sku: detail.sku,
      category: detail.category,
      changedAt: detail.changedAt || Timestamp.now(),
      changedBy: detail.changedBy || null,
      changedByLabel: detail.changedByLabel || null,
      source: detail.source || "inventory",
      type: detail.type || "updated",
      from: detail.from,
      to: detail.to,
    },
  };
};
